<header class="flex header">
  @if (assetModelProperty && assetModelProperty.id) {
    <h2>{{ 'Modal_ModelProperty.Edit' | translate }}</h2>
  } @else {
    <h2>{{ 'Modal_ModelProperty.Add' | translate }}</h2>
  }

  <p-button (onClick)="onClose()" icon="pi pi-times" />
</header>
<section class="content">
  <form [formGroup]="formModelGroup" class="w-full col">
    <!-- Name -->
    <div class="form-box">
      <label for="name">
        {{ 'Modal_ModelProperty.Name' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="name" formControlName="name" />
    </div>
    <!-- Description -->
    <div class="form-box">
      <label for="description">
        {{ 'Modal_ModelProperty.Description' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="description" formControlName="description" />
    </div>
    <!-- Type -->
    <div class="form-box">
      <label for="propertyType">{{ 'Modal_ModelProperty.Type' | translate }}</label>
      <p-select
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        fluid
        id="propertyType"
        [options]="propertyTypesArray"
        formControlName="propertyType"
        optionLabel="name"
        optionValue="id"
        [filter]="false"
        styleClass="w-full"
      />
    </div>
    <!-- Asset Level -->
    <div class="form-box">
      <label for="setValuesAtAssetLevel">
        {{ 'Modal_ModelProperty.setValueAtAssetLevel' | translate }}
      </label>
      <p-checkbox id="setValuesAtAssetLevel" formControlName="setValuesAtAssetLevel" [(ngModel)]="setValuesAtAssetLevel.value" [binary]="true" />
    </div>
    <!-- Allow Multiple Values -->
    <div class="form-box">
      <label for="multipleValues">
        {{ 'Modal_ModelProperty.allowMultipleValues' | translate }}
      </label>
      <p-checkbox id="multipleValues" formControlName="multipleValues" [(ngModel)]="multipleValues.value" [binary]="true" />
    </div>
    <!-- Default Value(s) -->
    <section *ngIf="!setValuesAtAssetLevel.value">
      <div class="under__line mb-[1rem]">
        <h3>
          {{ 'Modal_ModelProperty.DefaultValues' | translate }}
        </h3>
      </div>
      <div class="flow" *ngIf="multipleValues.value; else singleValue">
        <button (click)="addValue()" class="flat max-w-fit mb__1"><span class="material-icons">add</span>{{ 'Add' | translate }}</button>
        <ul class="col-sm">
          <li *ngFor="let value of defaultValues; let i = index" class="justify-between max-w-fit row-start-center font-medium px-2 py-1 rounded-full border-2">
            <p (click)="editValue(i)" class="px-2">{{ value }}</p>
            <button (click)="removeValue(i)" class="square">
              <span class="material-icons">close</span>
            </button>
            <p-button icon="pi pi-times" variant="text" (click)="removeValue(i)" />
          </li>
        </ul>

        <div *ngIf="isEditing">
          <input type="editingValue" [formControl]="editingValue" />
          <button (click)="saveValue()">{{ 'Save' | translate }}</button>
        </div>
      </div>
      <ng-template #singleValue>
        <div class="flow">
          <div class="form-box">
            <input pInputText type="text" class="w-full" id="defaultValue" [formControl]="defaultValue" />
          </div>
        </div>
      </ng-template>
    </section>

    <!-- Hidden until JWT are ready -->
    <!-- <h3 class="line">History</h3>
    <div class="form-box">
      <label for="createdBy">Created By</label>
      <p>{{ assetModelProperty?.createdBy }}</p>
    </div>
    <div class="form-box">
      <label for="modifiedBy">Modified By</label>
      <p>{{ assetModelProperty?.modifiedBy }}</p>
    </div>
    <div class="form-box">
      <label for="modifiedDate"> Modified Date </label>
      <p>{{ assetModelProperty?.modifiedDate | date: 'yyyy-MM-dd' }}</p>
    </div> -->
  </form>
</section>
<footer>
  <p-button class="w-full" [label]="'Save' | translate" [disabled]="formModelGroup.invalid" (click)="onSave()" />
  <p-button class="w-full" [label]="'Cancel' | translate" variant="outlined" (click)="onClose()" />
</footer>
